import { FileWithPath } from "@mantine/dropzone"
import { useMutation, useQuery } from "@tanstack/react-query"
import { useMemo } from "react"

import { IngestionResponses } from "@tfg/types/endpoints/ingestions"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient.ts"
import { useGetExportRequests } from "~/gen/api"

export const useIngestionsQuery = () => {
  return useQuery<IngestionResponses.Ingestion[]>(["ingestions"], async () => {
    const response = await httpClient.get(`ingestions`)
    return response.data
  })
}

export const useUploadIngestionFileMutation = () => {
  return useMutation(
    async (file: FileWithPath) => {
      const formData = new FormData()
      formData.set("file", file)

      const response = await httpClient.post("ingestions/upload", formData)
      return response.data
    },
    { onSuccess: () => queryClient.invalidateQueries(["ingestions"]) }
  )
}

export const useExportRequestsQuery = () => {
  const { data } = useGetExportRequests({
    query: {
      refetchInterval: 5000,
    },
  })

  const exportRequests = useMemo(() => {
    return data?.data || []
  }, [data])

  return exportRequests
}
